import React from "react";
import { Navigate } from "react-router-dom";
import { isAuthenticated, getUser } from "../auth";
import {
  buildAccessMapFromServices,
  hasAccess,
} from "../utils/roleAccess";

const ProtectedRoute = ({ children, page }) => {
  // 1️⃣ Authentication check
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  const user = getUser();

  // 2️⃣ Safety check
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // 3️⃣ Build access map from backend services
  const accessMap = buildAccessMapFromServices(user.services || []);

  // =====================================================
  // 4️⃣ DASHBOARD RULES (MUST BE FIRST)
  // =====================================================
 if (page === "dashboard") {
  // Customer → redirect ONLY if not already on customer dashboard
  if (
    user.userType === "customer" &&
    window.location.pathname !== "/customer/dashboard"
  ) {
    return <Navigate to="/customer/dashboard" replace />;
  }

  return children;
}


  // =====================================================
  // 5️⃣ CUSTOMER ROUTES (NON-DASHBOARD)
  // =====================================================
  if (user.userType === "customer") {
    return children;
  }

  // =====================================================
  // 6️⃣ PLATFORM USERS — PERMISSION CHECK
  // =====================================================
  const allowed = hasAccess(accessMap, page, "V");

  if (!allowed) {
    return <Navigate to="/dashboard" replace />;
  }

  // =====================================================
  // 7️⃣ AUTHORIZED
  // =====================================================
  return children;
};

export default ProtectedRoute;
